/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum army_sources {
  SUPPLEMENT = 'Supplement',
  OFFICIAL = 'Official',
  FAN_MADE = 'FanMade',
}
